// extracted by mini-css-extract-plugin
module.exports = {"image":"tF","hidden":"tG"};